module.exports = require('./endpoints')
console.log('hola2')
